/* tslint:disable */
/* eslint-disable */
/**
 * Autom8.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {exists} from '../runtime';
import {ScheduleLog, ScheduleLogFromJSON, ScheduleLogToJSON,} from './ScheduleLog';

/**
 *
 * @export
 * @interface ScheduleLogListApiResult
 */
export interface ScheduleLogListApiResult {
    /**
     *
     * @type {boolean}
     * @memberof ScheduleLogListApiResult
     */
    success?: boolean;
    /**
     *
     * @type {Array<ScheduleLog>}
     * @memberof ScheduleLogListApiResult
     */
    content?: Array<ScheduleLog> | null;
    /**
     *
     * @type {string}
     * @memberof ScheduleLogListApiResult
     */
    message?: string | null;
}

export function ScheduleLogListApiResultFromJSON(json: any): ScheduleLogListApiResult {
    return ScheduleLogListApiResultFromJSONTyped(json, false);
}

export function ScheduleLogListApiResultFromJSONTyped(json: any, ignoreDiscriminator: boolean): ScheduleLogListApiResult {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {

        'success': !exists(json, 'success') ? undefined : json['success'],
        'content': !exists(json, 'content') ? undefined : (json['content'] === null ? null : (json['content'] as Array<any>).map(ScheduleLogFromJSON)),
        'message': !exists(json, 'message') ? undefined : json['message'],
    };
}

export function ScheduleLogListApiResultToJSON(value?: ScheduleLogListApiResult | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {

        'success': value.success,
        'content': value.content === undefined ? undefined : (value.content === null ? null : (value.content as Array<any>).map(ScheduleLogToJSON)),
        'message': value.message,
    };
}

